<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('tradeIn.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('tradeIn.pageTitle'),
            href: '/admin/v2/trade-in'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <Info
                  v-model="model"
                  :validate="errors"
                  class="tw-p-3 tw-rounded"
                  @showProductList="() => (show_modal_add_product = true)"
                  @loading="val => (loading = val)"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ItemList
                  v-model="model"
                  :validate="errors"
                  class="tw-p-3 tw-rounded"
                />
              </div>
            </div>
            <div class="row ts-mt-4">
              <div
                class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end"
              >
                <ts-button
                  @click.prevent="$router.push({ name: 'trade-in' })"
                  >{{ $t('cancel') }}</ts-button
                >
                <ts-button
                  color="primary"
                  outline
                  :waiting="waiting_new"
                  @click.prevent="saveAddNew"
                  >{{ $t('saveAddNew') }}</ts-button
                >
                <ts-button
                  color="primary"
                  :waiting="waiting"
                  @click.prevent="save"
                  >{{ $t('save') }}</ts-button
                >
              </div>
            </div>
          </form>
        </ts-loading-banner>
        <!-- modal show pop-up to be able add product -->
        <a-modal
          v-if="show_modal_add_product"
          v-model="show_modal_add_product"
          :footer="null"
          :zIndex="1020"
          :maskClosable="false"
          width="800px"
          :title="$t('tradeIn.product')"
        >
          <ProductList v-model="model" />
        </a-modal>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import ItemList from './components/item-list.vue'
import Info from './components/info.vue'
import moment from 'moment'
import { mapActions } from 'vuex'
import ProductList from './components/product-list.vue'

export default {
  name: 'tradeInCreate',
  components: {
    Info,
    ItemList,
    ProductList
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting_new: false,
      waiting: false,
      show_modal_add_product: false,
      model: {
        trade_in_id: null,
        trade_in_date: moment().format('DD-MM-YYYY'),
        ref_stock_out_id: null,
        reference_no: null,
        customer_id: null,
        currency_id: null,
        input_currency_id: null,
        fx_rate: 1,
        fx_rate_ratio: 1,
        remarks: null,
        invoice_amount: null,
        product_details: []
      }
    }
  },
  methods: {
    ...mapActions('stock/tradeIn', ['getFormViewModel', 'store']),
    async getPreData({ params, index }) {
      this.loading = true
      await this.getFormViewModel({ index: index, params: params })
        .then(response => {
          let default_currency = response.data.currency.find(
            el => el.is_default == true
          )
          this.model.currency_id = default_currency
            ? default_currency.currency_id
            : null
          this.model.input_currency_id = default_currency
            ? default_currency.currency_id
            : null
          this.model.fx_rate = 1
          this.model.fx_rate_ratio = 1
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    save() {
      this.waiting = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'trade-in' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    saveAddNew() {
      this.waiting_new = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput() {
      this.model.trade_in_id = null
      this.model.trade_in_date = moment().format('DD-MM-YYYY')
      this.model.ref_stock_out_id = null
      this.model.reference_no = null
      this.model.customer_id = null
      this.model.currency_id = null
      this.model.input_currency_id = null
      this.model.invoice_amount = null
      this.model.fx_rate = 1
      this.model.fx_rate_ratio = 1
      this.model.remarks = null
      this.model.product_details = []
      this.errors = new Errors()
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPreData({
        params: {},
        index: undefined
      })
    })
  }
}
</script>
